export function HorizontalLine() {
    return (
        <hr className="h-px border-0 bg-linear-to-r from-primary/80 via-border to-transparent text-transparent"/>
    )
}
